import React, { useEffect, useState } from "react";
import { 
  Table, 
  Button, 
  Input, 
  Select, 
  Switch, 
  Modal, 
  Form, 
  InputNumber, 
  Tag, 
  Space, 
  Popconfirm, 
  message, 
  Row, 
  Col, 
  Card,
  Tooltip,
  Upload,
  Spin,
  Tabs
} from "antd";
import { 
  PlusOutlined, 
  SearchOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  ReloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  UploadOutlined,
  PictureOutlined,
  InfoCircleOutlined,
  ShoppingOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  TagsOutlined,
  DollarOutlined
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import axios from "axios";
import { postingService } from "../../shared";

const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

const Medicines = () => {
  const [form] = Form.useForm();
  const [categoryForm] = Form.useForm();
  const { token } = useSelector((state) => state.Authentication.user);
  const { allcities = [] } = useSelector((state) => state.Cities || {});

  // Tab State
  const [activeTab, setActiveTab] = useState("products");

  // Products states
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  
  // Products filtering states
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [subcategoryFilter, setSubcategoryFilter] = useState("");

  // Product Modals
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);

  // Dynamic Categories database list state
  const [categoriesList, setCategoriesList] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  // Category Modal state
  const [isCatModalOpen, setIsCatModalOpen] = useState(false);
  const [editingCatId, setEditingCatId] = useState(null);
  const [submittingCat, setSubmittingCat] = useState(false);

  // Watchers for reactive subcategory loading in Product Form
  const [formSelectedCategory, setFormSelectedCategory] = useState("");

  // Fetch dynamic categories from the database
  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      const response = await axios.get(`${postingService}/api/v1/admin/categories`, {
        headers: {
          Authorization: `bearer ${token}`,
          "api-key": "poultrybaba@1234Sumandri"
        }
      });
      if (response.data && response.data.success) {
        let list = response.data.data || [];
        setCategoriesList(list);

        // Auto-seed default categories if database is completely empty
        if (list.length === 0) {
          await seedDefaultCategories();
        }
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
      message.error("Failed to fetch e-commerce categories.");
    } finally {
      setLoadingCategories(false);
    }
  };

  // Seeding helper to pre-fill standard B2B Poultry categories
  const seedDefaultCategories = async () => {
    const defaultCats = [
      { name: "MEDICINE", subcategories: ["Medicine", "Organic Acid", "Growth Promotor", "Vaccine", "Liver Tonic", "General"] },
      { name: "VACCINE", subcategories: ["Lasota", "Gumboro", "H120", "Coryza", "Fowl Pox", "AI (H9)", "Cocci", "Salmonella"] },
      { 
        name: "FEED", 
        subcategories: [
          "Feed Ingredients", "Maize", "Soybean Meal", "Canola Meal", "Rice Polish", "Wheat Bran", "Corn Gluten", "Fish Meal", "Meat Meal", "Limestone", "DCP", "Salt", "Methionine", "Lysine", "Threonine",
          "Broiler Feed", "Pre Starter", "Starter", "Grower", "Finisher", "Withdrawal Feed",
          "Layer Feed", "Chick Mash", "Grower Mash", "Pre Layer", "Layer Phase 1", "Layer Phase 2", "Layer Phase 3", "Layer Concentrate",
          "Breeder Feed", "Breeder Starter", "Male Breeder", "Female Breeder", "Parent Stock",
          "Feed Supplements", "Vitamins", "Minerals", "Probiotics", "Enzymes", "Toxin Binder", "Acidifier",
          "Cattle Feed", "Dairy Feed", "Calf Starter", "Buffalo Feed", "Cow Feed", "Beef Feed", "Fattening Feed", "Mineral Mix", "Silage Additives", "TMR Supplements",
          "Aqua Feed", "Fish Starter", "Fish Grower", "Fish Finisher", "Shrimp Feed", "Carp Feed", "Tilapia Feed", "Trout Feed", "Floating Feed", "Sinking Feed"
        ] 
      },
      { name: "CHICKS & BIRDS", subcategories: ["White Layer Chick", "Brown Layer Chick", "Broiler Chick", "Misri Golden Chick"] },
      { name: "EQUIPMENT", subcategories: ["Feeding & Drinking", "Brooding & Heating", "Ventilation & Cages", "Farm Automation", "Biosecurity & Misc"] }
    ];

    try {
      for (const cat of defaultCats) {
        await axios.post(`${postingService}/api/v1/admin/categories`, cat, {
          headers: {
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        });
      }
      // Re-fetch list
      const response = await axios.get(`${postingService}/api/v1/admin/categories`, {
        headers: {
          Authorization: `bearer ${token}`,
          "api-key": "poultrybaba@1234Sumandri"
        }
      });
      if (response.data && response.data.success) {
        setCategoriesList(response.data.data || []);
        message.success("Successfully seeded initial poultry e-commerce categories! 🎉");
      }
    } catch (err) {
      console.error("Seeding failed:", err);
    }
  };

  // Fetch products from backend posts-service
  const fetchProducts = async (targetPage = page, querySearch = search, catFilter = categoryFilter, subcatFilter = subcategoryFilter) => {
    setLoading(true);
    try {
      const response = await axios.get(`${postingService}/api/v1/admin/medicines`, {
        params: {
          page: targetPage,
          limit,
          search: querySearch,
          category: catFilter,
          subcategory: subcatFilter
        },
        headers: {
          Authorization: `bearer ${token}`,
          "api-key": "poultrybaba@1234Sumandri"
        }
      });

      if (response.data && response.data.success) {
        setData(response.data.docs || []);
        setTotal(response.data.totalDocs || 0);
      } else {
        message.error("Failed to load products list.");
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      message.error("Error connecting to backend posts-service.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchCategories();
      fetchProducts(1, "", "", "");
    }
  }, [token]);

  // Handle Search Trigger
  const handleSearch = () => {
    fetchProducts(1, search, categoryFilter, subcategoryFilter);
    setPage(1);
  };

  // Handle Reset Filter Trigger
  const handleReset = () => {
    setSearch("");
    setCategoryFilter("");
    setSubcategoryFilter("");
    fetchProducts(1, "", "", "");
    setPage(1);
  };

  // Toggle Active/Inactive status
  const handleToggleStatus = async (record) => {
    try {
      const response = await axios.patch(
        `${postingService}/api/v1/admin/medicines/${record._id}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        }
      );

      if (response.data && response.data.success) {
        message.success(`Product status changed to ${response.data.data.isActive ? "Active" : "Inactive"}`);
        // Refresh local list state
        setData(data.map(item => item._id === record._id ? { ...item, isActive: response.data.data.isActive } : item));
      } else {
        message.error("Failed to update status.");
      }
    } catch (err) {
      console.error("Error toggling status:", err);
      message.error("Failed to update toggle action on server.");
    }
  };

  // Delete Medicine Product
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${postingService}/api/v1/admin/medicines/${id}`, {
        headers: {
          Authorization: `bearer ${token}`,
          "api-key": "poultrybaba@1234Sumandri"
        }
      });

      if (response.data && response.data.success) {
        message.success("Product deleted successfully.");
        fetchProducts(page, search, categoryFilter, subcategoryFilter);
      } else {
        message.error("Failed to delete product.");
      }
    } catch (err) {
      console.error("Error deleting product:", err);
      message.error("Failed to communicate delete action to server.");
    }
  };

  // Open Create Product Modal
  const handleOpenCreate = () => {
    setEditingId(null);
    form.resetFields();
    setImageUrl("");
    setFormSelectedCategory("");
    form.setFieldsValue({ isActive: true, image: "", category: "", cities: [] });
    setIsModalOpen(true);
  };

  // Open Edit Product Modal
  const handleOpenEdit = (record) => {
    setEditingId(record._id);
    form.resetFields();
    setImageUrl(record.image || "");
    setFormSelectedCategory(record.category || "");
    form.setFieldsValue({
      name: record.name,
      description: record.description,
      price: record.price,
      category: record.category || "",
      subcategory: record.subcategory,
      image: record.image || "",
      cities: record.cities || [],
      brand: record.brand || "",
      discount: record.discount || 0,
      tags: record.tags ? record.tags.join(", ") : "",
      isActive: record.isActive
    });
    setIsModalOpen(true);
  };

  // Direct secure CORS-immune server-assisted upload to Google Cloud Storage bucket
  const handleUploadImageFile = async (file) => {
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(
        `${postingService}/api/v1/posts/upload-to-gcs`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        }
      );

      if (response.data && response.data.success && response.data.downloadUrl) {
        const { downloadUrl } = response.data;
        message.success("Image uploaded to cloud successfully!");
        setImageUrl(downloadUrl);
        form.setFieldsValue({ image: downloadUrl });
      } else {
        message.error("Failed to upload image. Unexpected response from server.");
      }
    } catch (err) {
      console.error("Error during upload flow:", err);
      const exactError = err.response?.data?.message || err.message || err.toString();
      message.error(`Upload failed: ${exactError}. Please check browser console for more details.`);
    } finally {
      setUploading(false);
    }
    return false; // Prevent default upload behavior
  };

  // Handle Product Submit
  const handleFormSubmit = async (values) => {
    setSubmitting(true);
    try {
      const processedTags = values.tags
        ? values.tags.split(",").map(t => t.trim()).filter(t => t.length > 0)
        : [];

      const payload = {
        name: values.name,
        description: values.description,
        price: values.price,
        category: values.category,
        subcategory: values.subcategory,
        image: values.image,
        cities: values.cities || [],
        brand: values.brand || "",
        discount: values.discount || 0,
        tags: processedTags,
        isActive: values.isActive
      };

      let response;
      if (editingId) {
        response = await axios.put(`${postingService}/api/v1/admin/medicines/${editingId}`, payload, {
          headers: {
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        });
      } else {
        response = await axios.post(`${postingService}/api/v1/admin/medicines`, payload, {
          headers: {
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        });
      }

      if (response.data && response.data.success) {
        message.success(`Product ${editingId ? "updated" : "created"} successfully!`);
        setIsModalOpen(false);
        fetchProducts(editingId ? page : 1, search, categoryFilter, subcategoryFilter);
        if (!editingId) setPage(1);
      } else {
        message.error("Submission failed.");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      message.error("Failed to connect to the backend server.");
    } finally {
      setSubmitting(false);
    }
  };

  // Open Create Category Modal
  const handleOpenCreateCategory = () => {
    setEditingCatId(null);
    categoryForm.resetFields();
    setIsCatModalOpen(true);
  };

  // Open Edit Category Modal
  const handleOpenEditCategory = (record) => {
    setEditingCatId(record._id);
    categoryForm.resetFields();
    categoryForm.setFieldsValue({
      name: record.name,
      subcategories: record.subcategories || []
    });
    setIsCatModalOpen(true);
  };

  // Handle Category Submit
  const handleCategoryFormSubmit = async (values) => {
    setSubmittingCat(true);
    try {
      const payload = {
        name: values.name,
        subcategories: values.subcategories || []
      };

      let response;
      if (editingCatId) {
        response = await axios.put(`${postingService}/api/v1/admin/categories/${editingCatId}`, payload, {
          headers: {
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        });
      } else {
        response = await axios.post(`${postingService}/api/v1/admin/categories`, payload, {
          headers: {
            Authorization: `bearer ${token}`,
            "api-key": "poultrybaba@1234Sumandri"
          }
        });
      }

      if (response.data && response.data.success) {
        message.success(`Category ${editingCatId ? "updated" : "created"} successfully!`);
        setIsCatModalOpen(false);
        fetchCategories();
      } else {
        message.error(response.data.message || "Failed to submit category.");
      }
    } catch (err) {
      console.error("Category submission failed:", err);
      message.error(err.response?.data?.message || "Failed to connect to server.");
    } finally {
      setSubmittingCat(false);
    }
  };

  // Delete Category
  const handleDeleteCategory = async (id) => {
    try {
      const response = await axios.delete(`${postingService}/api/v1/admin/categories/${id}`, {
        headers: {
          Authorization: `bearer ${token}`,
          "api-key": "poultrybaba@1234Sumandri"
        }
      });
      if (response.data && response.data.success) {
        message.success("Category deleted successfully.");
        fetchCategories();
      } else {
        message.error("Failed to delete category.");
      }
    } catch (err) {
      console.error("Error deleting category:", err);
      message.error("Failed to delete category.");
    }
  };

  // Resolve subcategories based on currently selected Category object
  const getSubcategoriesOfCategory = (categoryName) => {
    const cat = categoriesList.find(c => c.name === categoryName);
    return cat ? cat.subcategories : [];
  };

  // Helper to extract display name for city list
  const getCityDisplayName = (cityObj) => {
    return cityObj.cityName || cityObj.name || cityObj.city || cityObj.division || "Unknown";
  };

  // Product List Table Columns
  const productColumns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 90,
      render: (image) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img 
            src={image || "/assets/1.png"} 
            alt="product" 
            style={{ 
              width: "50px", 
              height: "50px", 
              borderRadius: "10px", 
              objectFit: "cover",
              border: "2px solid #FF9E1B",
              boxShadow: "0 4px 10px rgba(110, 27, 6, 0.15)",
              transition: "all 0.3s ease"
            }} 
            className="medicine-thumbnail"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/1.png";
            }}
          />
        </div>
      )
    },
    {
      title: "Name & Info",
      dataIndex: "name",
      key: "name",
      render: (name, record) => (
        <div style={{ padding: "4px 0" }}>
          <strong style={{ fontSize: "16px", color: "#6E1B06", fontWeight: "700" }}>{name}</strong>
          {record.brand && (
            <span style={{ marginLeft: "8px", fontSize: "11px", backgroundColor: "#FF9E1B", color: "#fff", padding: "1px 6px", borderRadius: "4px", fontWeight: "600" }}>
              {record.brand}
            </span>
          )}
          {record.discount > 0 && (
            <span style={{ marginLeft: "6px", fontSize: "11px", backgroundColor: "#3f8600", color: "#fff", padding: "1px 6px", borderRadius: "4px", fontWeight: "600" }}>
              {record.discount}% OFF
            </span>
          )}
          <div style={{ color: "#555", fontSize: "12px", marginTop: "4px", maxWidth: "450px", lineHeight: "1.4" }}>
            {record.description && record.description.length > 100 
              ? `${record.description.substring(0, 100)}...` 
              : record.description}
          </div>
          <div style={{ marginTop: "6px", display: "flex", gap: "6px", flexWrap: "wrap", alignItems: "center" }}>
            {record.category && (
              <span style={{ fontSize: "11px", backgroundColor: "rgba(110, 27, 6, 0.08)", color: "#6E1B06", padding: "1px 8px", borderRadius: "12px", fontWeight: "700" }}>
                📁 {record.category}
              </span>
            )}
            {record.subcategory && (
              <span style={{ fontSize: "11px", backgroundColor: "rgba(24, 144, 255, 0.08)", color: "#1890ff", padding: "1px 8px", borderRadius: "12px", fontWeight: "700" }}>
                ⚙️ {record.subcategory}
              </span>
            )}
            {record.cities && record.cities.length > 0 && (
              <span style={{ fontSize: "11px", backgroundColor: "rgba(63, 134, 0, 0.08)", color: "#3f8600", padding: "1px 8px", borderRadius: "12px", fontWeight: "700" }}>
                📍 {record.cities.join(", ")}
              </span>
            )}
          </div>
        </div>
      )
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 130,
      render: (price) => (
        <span style={{ fontWeight: "800", color: "#6E1B06", fontSize: "15px" }}>
          Rs. {price?.toLocaleString()}
        </span>
      )
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      width: 130,
      render: (isActive, record) => (
        <Tooltip title={isActive ? "Visible on Marketplace" : "Hidden from Marketplace"}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Switch 
              checked={isActive} 
              onChange={() => handleToggleStatus(record)} 
              checkedChildren={<CheckCircleOutlined />}
              unCheckedChildren={<CloseCircleOutlined />}
              style={{
                backgroundColor: isActive ? "#3f8600" : "#cf1322"
              }}
            />
          </div>
        </Tooltip>
      )
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit Product">
            <Button 
              type="primary" 
              icon={<EditOutlined />} 
              size="middle" 
              onClick={() => handleOpenEdit(record)}
              style={{ borderRadius: "6px" }}
            />
          </Tooltip>
          <Tooltip title="Delete Product">
            <Popconfirm
              title="Delete this product catalog item?"
              onConfirm={() => handleDelete(record._id)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button 
                type="primary" 
                danger 
                icon={<DeleteOutlined />} 
                size="middle" 
                style={{ borderRadius: "6px" }}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      )
    }
  ];

  // Categories Table Columns
  const categoryColumns = [
    {
      title: "Category Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (name) => <strong style={{ color: "#6E1B06", fontSize: "15px" }}>{name}</strong>
    },
    {
      title: "Subcategories List",
      dataIndex: "subcategories",
      key: "subcategories",
      render: (subcats = []) => (
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {subcats.map((sc, i) => (
            <Tag key={i} color="orange" style={{ fontWeight: "600", borderRadius: "12px", border: "1px solid rgba(255, 158, 27, 0.3)" }}>
              {sc}
            </Tag>
          ))}
          {subcats.length === 0 && <span style={{ color: "#aaa", fontStyle: "italic" }}>No subcategories configured</span>}
        </div>
      )
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit Category & Subcategories">
            <Button 
              type="primary" 
              icon={<EditOutlined />} 
              onClick={() => handleOpenEditCategory(record)}
              style={{ borderRadius: "6px", backgroundColor: "#1890ff", borderColor: "#1890ff" }}
            >
              Edit
            </Button>
          </Tooltip>
          <Tooltip title="Delete Category">
            <Popconfirm
              title="Delete category and all its dynamic links? This cannot be undone."
              onConfirm={() => handleDeleteCategory(record._id)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button 
                type="primary" 
                danger 
                icon={<DeleteOutlined />} 
                style={{ borderRadius: "6px" }}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: "15px" }}>
      <style dangerouslySetInnerHTML={{__html: `
        .medicines-table .ant-table-thead > tr > th {
          background-color: #f7f5f2 !important;
          color: #6E1B06 !important;
          font-weight: 800 !important;
          font-size: 14px !important;
          border-bottom: 2px solid #e2dcd5 !important;
        }
        .medicines-table .ant-table-row {
          transition: all 0.3s ease !important;
        }
        .medicines-table .ant-table-row:hover > td {
          background-color: #FFFDF9 !important;
        }
        .medicine-thumbnail:hover {
          transform: scale(1.1) rotate(2deg);
          border-color: #6E1B06 !important;
          box-shadow: 0 6px 12px rgba(110, 27, 6, 0.25) !important;
        }
        .filter-panel {
          box-shadow: 0 4px 15px rgba(110, 27, 6, 0.04) !important;
          border: 1px solid rgba(110, 27, 6, 0.06) !important;
        }
        .ant-form-item-label > label {
          color: #6E1B06 !important;
          font-weight: 700 !important;
        }
        .ant-tabs-nav-list {
          gap: 15px;
        }
        .ant-tabs-tab {
          font-size: 15px !important;
          font-weight: 700 !important;
          color: #777 !important;
          padding: 12px 10px !important;
          transition: all 0.3s !important;
        }
        .ant-tabs-tab-active {
          color: #6E1B06 !important;
        }
        .ant-tabs-ink-bar {
          background-color: #6E1B06 !important;
          height: 3px !important;
        }
      `}} />

      <Tabs 
        activeKey={activeTab} 
        onChange={setActiveTab}
        style={{ backgroundColor: "#fff", padding: "15px 24px", borderRadius: "14px", boxShadow: "0 10px 30px rgba(110,27,6,0.06)" }}
      >
        <TabPane tab="📦 Products Catalogue" key="products">
          <Card 
            title={
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <ShoppingOutlined style={{ fontSize: "24px", color: "#FF9E1B" }} />
                <span style={{ fontSize: "20px", fontWeight: "800", color: "#6E1B06" }}>
                  E-Commerce Marketplace Products
                </span>
              </div>
            } 
            bordered={false}
            extra={
              <Button 
                type="primary" 
                icon={<PlusOutlined />} 
                onClick={handleOpenCreate}
                style={{ 
                  background: "linear-gradient(135deg, #6E1B06 0%, #9E2B06 100%)", 
                  borderColor: "#6E1B06", 
                  borderRadius: "8px", 
                  height: "44px",
                  fontWeight: "700",
                  boxShadow: "0 4px 12px rgba(110, 27, 6, 0.35)",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                Add New Product
              </Button>
            }
          >
            {/* Filters Bar */}
            <div className="filter-panel" style={{ marginBottom: "25px", backgroundColor: "#FAF9F6", padding: "18px 20px", borderRadius: "12px" }}>
              <Row gutter={[16, 16]} align="middle">
                <Col xs={24} md={8}>
                  <Input 
                    placeholder="Search by name, tags..." 
                    prefix={<SearchOutlined style={{ color: "#bfbfbf", fontSize: "16px" }} />} 
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onPressEnter={handleSearch}
                    allowClear
                    style={{ height: "40px", borderRadius: "8px" }}
                  />
                </Col>
                <Col xs={12} md={5}>
                  <Select 
                    style={{ width: "100%" }} 
                    placeholder="Filter by Category"
                    value={categoryFilter || undefined}
                    onChange={(val) => {
                      setCategoryFilter(val || "");
                      setSubcategoryFilter(""); // reset subcategory on category change
                    }}
                    allowClear
                    size="large"
                  >
                    {categoriesList.map(cat => (
                      <Option key={cat._id} value={cat.name}>{cat.name}</Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={12} md={5}>
                  <Select 
                    style={{ width: "100%" }} 
                    placeholder="Filter by Subcategory"
                    value={subcategoryFilter || undefined}
                    onChange={(val) => setSubcategoryFilter(val || "")}
                    disabled={!categoryFilter}
                    allowClear
                    size="large"
                  >
                    {getSubcategoriesOfCategory(categoryFilter).map(sub => (
                      <Option key={sub} value={sub}>{sub}</Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={24} md={6}>
                  <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                    <Button 
                      type="primary" 
                      icon={<SearchOutlined />} 
                      onClick={handleSearch}
                      style={{ height: "40px", borderRadius: "8px", backgroundColor: "#6E1B06", borderColor: "#6E1B06", fontWeight: "600" }}
                    >
                      Filter
                    </Button>
                    <Button 
                      icon={<ReloadOutlined />} 
                      onClick={handleReset}
                      style={{ height: "40px", borderRadius: "8px", fontWeight: "600" }}
                    >
                      Reset
                    </Button>
                  </Space>
                </Col>
              </Row>
            </div>

            <Table 
              columns={productColumns} 
              dataSource={data} 
              rowKey="_id"
              loading={loading}
              className="medicines-table"
              pagination={{
                current: page,
                pageSize: limit,
                total: total,
                onChange: (p) => {
                  setPage(p);
                  fetchProducts(p, search, categoryFilter, subcategoryFilter);
                },
                showTotal: (t) => (
                  <span style={{ fontWeight: "700", color: "#6E1B06" }}>
                    Total {t} items registered
                  </span>
                )
              }}
            />
          </Card>
        </TabPane>

        <TabPane tab="⚙️ Category & Subcategory Settings" key="categories">
          <Card 
            title={
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <SettingOutlined style={{ fontSize: "24px", color: "#FF9E1B" }} />
                <span style={{ fontSize: "20px", fontWeight: "800", color: "#6E1B06" }}>
                  Manage Dynamic Product Categories
                </span>
              </div>
            } 
            bordered={false}
            extra={
              <Button 
                type="primary" 
                icon={<PlusOutlined />} 
                onClick={handleOpenCreateCategory}
                style={{ 
                  backgroundColor: "#FF9E1B", 
                  borderColor: "#FF9E1B", 
                  borderRadius: "8px", 
                  height: "44px",
                  fontWeight: "700",
                  boxShadow: "0 4px 10px rgba(255, 158, 27, 0.25)"
                }}
              >
                Create Category
              </Button>
            }
          >
            <div style={{ marginBottom: "15px", color: "#777", fontSize: "14px" }}>
              <InfoCircleOutlined style={{ color: "#FF9E1B" }} /> Yahan se aap website ke poultry plaza ke category aur subcategory filters ko direct add/delete/update kar sakte hain bina code change kiye!
            </div>

            <Table 
              columns={categoryColumns} 
              dataSource={categoriesList} 
              rowKey="_id"
              loading={loadingCategories}
              className="medicines-table"
              pagination={false}
            />
          </Card>
        </TabPane>
      </Tabs>

      {/* Product Add/Edit Modal */}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingBottom: "10px", borderBottom: "1px solid #f0f0f0" }}>
            <ShoppingOutlined style={{ fontSize: "20px", color: "#FF9E1B" }} />
            <span style={{ fontSize: "20px", fontWeight: "800", color: "#6E1B06" }}>
              {editingId ? "Edit E-Commerce Product" : "Post E-Commerce Product"}
            </span>
          </div>
        }
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        destroyOnClose
        width={800}
        style={{ top: 25, borderRadius: "14px", overflow: "hidden" }}
        bodyStyle={{ maxHeight: "calc(100vh - 220px)", overflowY: "auto", padding: "20px 24px" }}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px 24px", borderTop: "1px solid #f0f0f0" }}>
            <Button onClick={() => setIsModalOpen(false)} style={{ height: "40px", borderRadius: "6px" }}>Cancel</Button>
            <Button type="primary" form="productForm" htmlType="submit" loading={submitting} style={{ backgroundColor: "#6E1B06", borderColor: "#6E1B06", borderRadius: "6px", height: "40px", fontWeight: "700" }}>
              {editingId ? "Save Product" : "Publish Product"}
            </Button>
          </div>
        }
      >
        <Form
          id="productForm"
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          onValuesChange={(changedValues) => {
            if (changedValues.hasOwnProperty("image")) {
              setImageUrl(changedValues.image || "");
            }
            if (changedValues.hasOwnProperty("category")) {
              setFormSelectedCategory(changedValues.category || "");
              form.setFieldsValue({ subcategory: "" }); // reset subcat on cat change
            }
          }}
        >
          <Row gutter={[24, 24]}>
            <Col xs={24} md={15}>
              <Form.Item
                name="name"
                label="Product / Item Name"
                rules={[{ required: true, message: "Please input product name!" }]}
              >
                <Input placeholder="e.g. Doxycycline WISP, Starter Feed 112..." style={{ height: "40px", borderRadius: "6px" }} />
              </Form.Item>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="category"
                    label="Product Category"
                    rules={[{ required: true, message: "Please select product category!" }]}
                  >
                    <Select placeholder="Select Category" size="large">
                      {categoriesList.map(cat => (
                        <Option key={cat._id} value={cat.name}>{cat.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="subcategory"
                    label="Product Subcategory"
                    rules={[{ required: true, message: "Please select product subcategory!" }]}
                  >
                    <Select placeholder="Select Subcategory" size="large" disabled={!formSelectedCategory}>
                      {getSubcategoriesOfCategory(formSelectedCategory).map(sub => (
                        <Option key={sub} value={sub}>{sub}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="price"
                    label="Price (PKR)"
                    rules={[{ required: true, message: "Please enter product price!" }]}
                  >
                    <InputNumber style={{ width: "100%", height: "40px", borderRadius: "6px", display: "flex", alignItems: "center" }} min={1} placeholder="Enter price in Rs." />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="discount"
                    label="Discount Percentage (%)"
                  >
                    <InputNumber style={{ width: "100%", height: "40px", borderRadius: "6px", display: "flex", alignItems: "center" }} min={0} max={100} placeholder="e.g. 25 for 25% off (Optional)" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="brand"
                    label="Brand Name"
                  >
                    <Input placeholder="e.g. Solomon, Jadeed, Hi-Tech (Optional)" style={{ height: "40px", borderRadius: "6px" }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="cities"
                    label={
                      <span>
                        <EnvironmentOutlined style={{ marginRight: "4px", color: "#FF9E1B" }} /> Select Cities Availability
                      </span>
                    }
                    rules={[{ required: true, message: "Please select at least one city!" }]}
                  >
                    <Select 
                      mode="multiple" 
                      placeholder="Search/Select cities..." 
                      size="large"
                      style={{ width: "100%" }}
                      optionFilterProp="children"
                    >
                      {allcities.map((city, idx) => (
                        <Option key={idx} value={getCityDisplayName(city)}>
                          {getCityDisplayName(city)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name="image"
                label="Product Image (GCS Secure Upload)"
                rules={[{ required: true, message: "Please enter or upload an image path!" }]}
              >
                <div style={{ display: "flex", width: "100%", gap: "8px", flexWrap: "wrap" }}>
                  <Form.Item name="image" noStyle rules={[{ required: true, message: "Image path required" }]}>
                    <Input style={{ flex: 1, minWidth: "200px", height: "40px", borderRadius: "6px" }} placeholder="Paste image link, or upload file..." allowClear />
                  </Form.Item>
                  <Upload accept="image/*" showUploadList={false} beforeUpload={handleUploadImageFile}>
                    <Button icon={<UploadOutlined />} loading={uploading} style={{ height: "40px", backgroundColor: "#6E1B06", color: "#fff", borderColor: "#6E1B06", borderRadius: "6px" }}>
                      Browse File
                    </Button>
                  </Upload>
                </div>
                {uploading && <div style={{ color: "#1890ff", fontSize: "12px", marginTop: "4px" }}><Spin size="small" style={{ marginRight: "8px" }} />Uploading to cloud...</div>}
              </Form.Item>

              <Form.Item name="tags" label="Search Tags (Comma separated)" help="Example: feed, broiler booster, feed additive">
                <Input placeholder="Add custom tags separated by commas..." style={{ height: "40px", borderRadius: "6px" }} />
              </Form.Item>

              <Form.Item name="description" label="Detailed Product Specifications" rules={[{ required: true, message: "Please input product description!" }]}>
                <TextArea rows={4} placeholder="Add product dosage, dimensions, weight, instructions, etc." style={{ borderRadius: "6px" }} />
              </Form.Item>
            </Col>

            <Col xs={24} md={9} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Card
                title={<span><PictureOutlined style={{ marginRight: "6px", color: "#FF9E1B" }} />Product Preview</span>}
                style={{ borderRadius: "12px", textAlign: "center", backgroundColor: "#FAF9F6", height: "260px", display: "flex", flexDirection: "column", justifyHeight: "center" }}
                bodyStyle={{ display: "flex", flexDirection: "column", alignItems: "center", justifyHeight: "center", flex: 1, padding: "10px" }}
              >
                {imageUrl ? (
                  <div>
                    <img src={imageUrl} alt="preview" style={{ maxHeight: "150px", borderRadius: "8px", border: "2px solid #FF9E1B", backgroundColor: "#fff" }} />
                    <div style={{ fontSize: "11px", color: "#3f8600", marginTop: "10px", fontWeight: "700" }}>Live Image Connected</div>
                  </div>
                ) : (
                  <div>
                    <PictureOutlined style={{ fontSize: "40px", color: "#e2dcd5", marginBottom: "8px" }} />
                    <div style={{ fontSize: "12px", color: "#8c8c8c" }}>Select file or paste link to preview</div>
                  </div>
                )}
              </Card>

              <Card style={{ borderRadius: "12px", border: "1px solid rgba(110,27,6,0.08)", backgroundColor: "#FAF9F6" }}>
                <Form.Item name="isActive" label="List on Marketplace Immediately" valuePropName="checked" style={{ marginBottom: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                    <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    <span style={{ fontSize: "12px", fontWeight: "600", color: "#6e1b06" }}>Active for sale</span>
                  </div>
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Category Add/Edit Modal */}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingBottom: "10px", borderBottom: "1px solid #f0f0f0" }}>
            <SettingOutlined style={{ fontSize: "20px", color: "#FF9E1B" }} />
            <span style={{ fontSize: "20px", fontWeight: "800", color: "#6E1B06" }}>
              {editingCatId ? "Edit Product Category" : "Create Product Category"}
            </span>
          </div>
        }
        visible={isCatModalOpen}
        onCancel={() => setIsCatModalOpen(false)}
        destroyOnClose
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button onClick={() => setIsCatModalOpen(false)}>Cancel</Button>
            <Button type="primary" form="categoryForm" htmlType="submit" loading={submittingCat} style={{ backgroundColor: "#FF9E1B", borderColor: "#FF9E1B", fontWeight: "700" }}>
              {editingCatId ? "Save Category" : "Publish Category"}
            </Button>
          </div>
        }
      >
        <Form
          id="categoryForm"
          form={categoryForm}
          layout="vertical"
          onFinish={handleCategoryFormSubmit}
        >
          <Form.Item
            name="name"
            label="Category Name"
            rules={[{ required: true, message: "Please input category name!" }]}
          >
            <Input placeholder="e.g. Feed, Machinery, Grains..." style={{ height: "40px", borderRadius: "6px" }} />
          </Form.Item>

          <Form.Item
            name="subcategories"
            label="Subcategories List"
            help="Type a subcategory name and press Enter to add multiple"
          >
            <Select 
              mode="tags" 
              placeholder="e.g. vitamins, vaccines, parent stock" 
              style={{ width: "100%" }}
              tokenSeparators={[',']}
              size="large"
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Medicines;
